<template>
  <div>
    <!-- <p class="c-inner-title">图片</p> -->
    <div class="auto">
      <page-title title="图片" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="8">
              <el-button type="primary" size="small" @click="AddPicHandle()">添加图片</el-button>
              <el-button type="primary" size="small" :disabled="Boolean(authorizer['mp_sync_image'])" :loading="syncLoading" @click="syncWxMaterial()">同步素材</el-button>
            </el-col>
            <el-col :span="16" class="flex-box j-c-e">
              <div>
                <dates-picker v-model="filter.date" size="small"></dates-picker>
              </div>
              <el-input v-model="filter.search" size="small" clearable class="m-lr-5" style="width:200px;" placeholder="请输入标题"><i class="el-icon-search el-input__icon" slot="suffix"></i></el-input>
              <el-button type="primary" size="small" @click="handleChangeFilter()">搜索</el-button>
            </el-col>
          </el-row>
          <el-table :data="totalData" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="media_id" label="MediaId"></el-table-column>
            <el-table-column label="图片" width="120">
              <template slot-scope="scope">
                <div class="imgbox">
                  <!-- <img :src="scope.row.url || scope.row['extra']['media_url']" alt=""> -->
                  <el-image
                    style="width: 100px;height: 100px;"
                    :src="scope.row.url || scope.row['extra']['media_url']"
                    fit="scale-down"
                    :preview-src-list="[scope.row.url || scope.row['extra']['media_url']]">
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="名称"></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column prop="download_status_name" label="状态"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="deleteHandle(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="count > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="添加图片" :modal-append-to-body="false" @close="closeDialog" :visible="dialogAdd">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" v-loading="btnLoading">
        <el-form-item label="图片标题" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请填写图片标题"></el-input>
        </el-form-item>
        <el-form-item label="上传图片" prop="img">
          <el-upload
            class="avatar-uploader"
            :action="config.root + '/mp/material/uploadMaterial'"
            :data="uploadData"
            :show-file-list="false"
            v-loading="uploadLoading"
            :on-success="handleAvatarSuccess"
            :on-error="uploadError"
            :before-upload="beforeAvatarUpload">
            <img v-if="ruleForm.img" :src="ruleForm.img" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitFn('ruleForm')" >确定</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VueCookie from 'vue-cookie'
import { Mp, Auth } from '@/model'
import Config from '@/conf'
export default {
  data () {
    let token = VueCookie.get(Config['token_key'])
    let authorizer = VueCookie.get(Config['current_key'])
    return {
      uploadData: {
        token: token,
        authorizer: authorizer
      },
      totalData: [],
      loading: false,
      syncLoading: false,
      uploadLoading: false,
      btnLoading: false,
      changeName: '',
      dialogAdd: false,
      file: {
        media_id: '',
        oss_url: '',
        url: ''
      },
      ruleForm: {
        name: '',
        img: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入图片名称', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ]
      },
      filter: {
        date: '',
        material_type: 'image',
        search: '',
        page: '1',
        limit: '10'
      },
      count: 0
    }
  },
  watch: {
    '$route': function (val) {
      this.queryToFilter()
    }
  },
  computed: {
    ...mapGetters([
      'authorizer'
    ])
  },
  methods: {
    async updateUser () {
      let res = await Auth.getUserInfo({'authorizer': this.$cookie.get(Config['current_key'])})
      if (res['err_code'] === 0 && res['data']['user']) {
        res['data']['authorizer']['service_type_info'] = res['data']['authorizer'].service_type_info ? JSON.parse(res['data']['authorizer'].service_type_info) : ''
        res['data']['authorizer']['verify_type_info'] = res['data']['authorizer'].verify_type_info ? JSON.parse(res['data']['authorizer'].verify_type_info) : ''
        res['data']['authorizer']['business_info'] = res['data']['authorizer'].business_info ? JSON.parse(res['data']['authorizer'].business_info) : ''
        this.$store.dispatch('authorizer', res['data']['authorizer'])
      }
    },
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        date: '',
        material_type: 'image',
        search: '',
        page: '1',
        limit: '10'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/material/picture', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    handleAvatarSuccess (res, file) {
      this.file = file.response
      this.ruleForm.img = URL.createObjectURL(file.raw)
      this.uploadLoading = false
    },
    beforeAvatarUpload (file) {
      this.uploadLoading = true
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        this.uploadLoading = false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        this.uploadLoading = false
      }
      return isJPG && isLt2M
    },
    uploadError () {
      this.uploadLoading = false
      this.$message.error('上传失败，请重新上传')
    },
    AddPicHandle () {
      this.dialogAdd = true
    },
    deleteHandle (index) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteFn(this.totalData[index].media_id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async deleteFn (mediaId) {
      this.loading = true
      let res = await Mp.Material.delWxMaterial({material_type: this.filter.material_type, media_id: mediaId})
      if (res.err_code !== 0) {
        this.$message.error(res.err_msg)
        this.loading = false
      } else {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getList()
      }
    },
    closeDialog () {
      this.dialogAdd = false
      this.$refs['ruleForm'].resetFields()
    },
    async getList () {
      this.loading = true
      let res = await Mp.Material.getList({
        material_type: this.filter.material_type,
        page: this.filter.page,
        limit: this.filter.limit,
        create_time: this.filter.date,
        search: this.filter.search
      })
      this.totalData = res['list']
      this.count = res['count']
      this.loading = false
      this.syncLoading = false
    },
    submitFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.uploadFn()
        } else {
          return false
        }
      })
    },
    async uploadFn () {
      this.btnLoading = true
      let res = await Mp.Material.doSubmitMedia({
        material_type: this.filter.material_type,
        title: this.ruleForm.name,
        url: this.file.url,
        oss_url: this.file['data'].oss_url,
        media_id: this.file.media_id
      })
      if (res.err_code !== 0) {
        this.$message.error(res.err_msg)
      } else {
        this.dialogAdd = false
        this.$message.success('添加成功')
        this.resetFilter()
        this.getList()
      }
      this.btnLoading = false
    },
    async syncWxMaterial () {
      this.loading = true
      this.syncLoading = true
      let res = await Mp.Material.syncWxMaterial({material_type: this.filter.material_type})
      if (res.err_code !== 0) {
        if (res.err_code === 2) {
          this.$alert(res.err_msg, '信息提示', {
            confirmButtonText: '确定'
          })
        } else {
          this.$message.error(res.err_msg)
        }
      } else {
        this.$store._vm.authorizer.mp_sync_image = 1
        this.$message.success('同步成功')
        this.resetFilter()
        this.getList()
      }
      this.syncLoading = false
      this.loading = false
    }
  },
  created () {
    this.queryToFilter()
    this.updateUser()
  }
}
</script>
<style scoped>
.imgbox{
  width: 100px;
  height: 100px;
  text-align: center;
  vertical-align: middle;
  display: -webkit-box;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.imgbox img{
  max-width: 100%;
  max-height: 100%;
  display: inline;
}
.searchbox {
  float: right;
  margin-left: 10px;
}
</style>
